import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import LandingNavBar from '../landing/NavBar';
import { useIntl } from 'react-intl';
import HeroPanel from '../landing/HeroPanel';
import { Helmet } from 'react-helmet';
import styles from './Landing.module.scss';
import FeaturePanels from '../landing/FeatureSection';
import BrandCarousel from '../landing/BrandCarousel';
import LandingFooter from '../landing/Footer';
import { Divider } from '@mantine/core';
import AppPreview from '../landing/AppPreview';
import InfoPanels from '../landing/InfoPanels';
import { LandingPageAnchorIds } from '@/utils/constants';
export default function Landing() {
    var intl = useIntl();
    var ref = React.useRef(null);
    useEffect(function() {
        if ('paintWorklet' in CSS) {
            // @ts-expect-error squircle is a custom paint worklet
            CSS.paintWorklet.addModule('https://www.unpkg.com/css-houdini-squircle/squircle.min.js');
        }
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.landing,
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "Mqu6qG",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Nightbot"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(LandingNavBar, {
                className: styles.navBar
            }),
            /*#__PURE__*/ _jsx(HeroPanel, {}),
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.brandCarouselContainer,
                children: [
                    /*#__PURE__*/ _jsx(BrandCarousel, {}),
                    /*#__PURE__*/ _jsx(Divider, {
                        className: styles.divider
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FeaturePanels, {
                id: LandingPageAnchorIds.FEATURES,
                className: styles.featurePanels
            }),
            /*#__PURE__*/ _jsx(AppPreview, {
                className: styles.appPreview
            }),
            /*#__PURE__*/ _jsx(InfoPanels, {
                id: LandingPageAnchorIds.LEARN_MORE,
                className: styles.infoPanels
            }),
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsx(LandingFooter, {})
        ]
    });
}
